import { Fragment } from "react";
import { SeparatorLinksRecipesContainer } from "./styles";
import ContentIcon from "@/shared/ContentIcon";
import { ContainerAuto } from "@/shared/ContainerAuto";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";
import { UnsubscribedModal } from "./components";
import { useSaveButton } from "./hooks/useSaveButton";
import { handleClick } from "@/shared/Analitics/GoogleAnalytics4";
import FoodCardLogin from "@/shared/ToolBarRecipes/FoodCardLogin";

const SeparatorLinksRecipes = () => {
  const dataContext = useContext(TemplateContext);
  const { content } = dataContext || {};
  const { handleRedirectColection, isOpenModal, setIsOpenModal, isOpenModalLoginToSave, setIsOpenModalLoginToSave, redirectLogin } =
    useSaveButton();

  return (
    <SeparatorLinksRecipesContainer>
      <ContainerAuto className="containerAutoFlex">
        <div className="links-recipes">
          <button
            className="links-recipes-title"
            onClick={() => { 
              handleClick("ui_interaction", "header recetas", "recetas guardadas"); 
              handleRedirectColection(); 
            }}
          >
            <ContentIcon
              width="13px"
              height="18px"
              nameIcon="bookmark-regular"
              className="links-recipes-title-icon"
            />
            <p className="links-recipes-title-text">RECETAS GUARDADAS</p>
          </button>

          <div className="links-recipes-items">
            {content?.dataHeader?.menuRecetas?.map((link, index) => {
              return (
                <Fragment key={index}>
                  <a className="links-recipes-link" href={link.slug} onClick={() => {
                    handleClick("ui_interaction", "header recetas", link.name);
                  }}>
                    {link.name}
                  </a>
                  <div className="links-recipes-dot"></div>
                </Fragment>
              );
            })}
          </div>
        </div>
      </ContainerAuto>
      {isOpenModal && <UnsubscribedModal setIsOpenModal={setIsOpenModal} />}
      {isOpenModalLoginToSave &&
        <div className="food-card-container">
          <FoodCardLogin
            onClose={() => {
              setIsOpenModalLoginToSave(false);
            }}
            iconClose={true}
            className={(isOpenModalLoginToSave) ? "isOpen" : ""}
            message="Registrate para guardar recetas."
            onLogin={redirectLogin}
            buttonLabel="Ingresar"
          />
        </div>
      }
    </SeparatorLinksRecipesContainer>
  );
};

export default SeparatorLinksRecipes;
